import { ESenderRole } from "../../setup/api/services/contract/models";

export const HEADER = "طلبات التحويل";
export const PENDING_CASHOUTS_TAB = "بانتظار التحويل";
export const FINISHED_CASHOUTS_TAB = "تم التحويل";
export const BUTTON = {
  SEARCH: "البحث عن طريق رمز المعاملة",
  SEARCH_TRANS: "البحث عن طريق رمز الدفع",
  SETTLED_AT_START_DATE: "تاريخ التسوية من",
  SETTLED_AT_END_DATE: "تاريخ التسوية إلى",
};

/** Format the settlement-date filter bounds are sent in, as in the contract lists. */
export const DATE_FILTER_FORMAT = "YYYY-MM-DD HH:mm";
export const TABLE_HEADERS = {
  TRANSACTION_NAME: "المعاملة",
  TRANSACTION_ID: "رمز المعاملة",
  CASHOUTS_NUMBER: "عدد التحويلات",
  TOTAL_AMOUNT: "القيمة الإجمالية",
  STATUS: "الحالة",
  AUTO_CASHOUT_ELIGIBILITY: "أهلية التحويل التلقائي",
  PARTIES_DATA: "اكتمال بيانات الأطراف",
  GRACE_PERIOD_REMAINING: "الوقت المتبقي لانتهاء فترة السماح",
};

export const AUTO_CASHOUT_ELIGIBLE = "مؤهل";
export const AUTO_CASHOUT_NOT_ELIGIBLE = "غير مؤهل";

export const PARTIES_DATA_COMPLETE = "مكتملة";
export const PARTIES_DATA_MISSING = "بيانات ناقصة";

export const PARTY_ROLE_LABELS: Partial<Record<ESenderRole, string>> = {
  [ESenderRole.PROVIDER]: "البائع",
  [ESenderRole.CUSTOMER]: "المشتري",
  [ESenderRole.BROKER]: "الوسيط",
};

export const MISSING_BANK_INFO_LABEL = "معلومات بنكية";
export const MISSING_ADDRESS_LABEL = "عنوان";
